export default __webpack_public_path__ + "static/media/PrebookModalHeaderImage.3b88a71b.png";